export default __webpack_public_path__ + "static/media/apple-store-3x.579fe24e.png";